/**
 * extensions/dicom-rt/src/hooks/useSuvStore.js
 *
 *   const stat = useSuv(makeSuvKey(structureSetUID, ROINumber, ctSeriesUID));
 *   const computing = useSuvComputing();
 *
 * Each subscribed component re-renders only when bridge notifies, which
 * happens after every per-ROI write → progressive UI updates.
 */

import { useEffect, useState } from 'react';
import {
  subscribe,
  getSuvByKey,
  isComputing,
} from '../modules/dicom-measurement/src/suv/suvViewportBridge';

function useBridgeTick() {
  const [, setTick] = useState(0);
  useEffect(() => {
    const unsubscribe = subscribe(() => setTick(t => t + 1));
    return unsubscribe;
  }, []);
}

/** Read one SUV entry by canonical key. Null if not computed yet. */
export function useSuv(key) {
  useBridgeTick();
  return getSuvByKey(key);
}

/** True while any SUV compute job is in flight. */
export function useSuvComputing() {
  useBridgeTick();
  return isComputing();
}
